/* 21-10: correzione barra spedizione gratuita.
   global.js definisce <free-delivery-bar> solo dopo il "load" della pagina e scrive l'importo
   con il punto (€46.50); se total == soglia mostrava entrambi i messaggi.
   Qui si sostituisce solo connectedCallback, senza toccare global.js. */
(function () {
  if (window.__clFreeDeliveryFix) return;
  window.__clFreeDeliveryFix = true;

  function update(el) {
    var rate = Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
    var threshold = Math.round(Number(el.getAttribute('data-price-max')) * rate);
    el.threshold = threshold;
    el.style.setProperty('--max-length', threshold);
    var cur = Number(String(getComputedStyle(el).getPropertyValue('--length')).trim());
    if (!isFinite(cur)) cur = 0;
    var full = el.querySelector('.free-delivery-bar__toolbar__full');
    var current = el.querySelector('.free-delivery-bar__toolbar__text__current');
    if (cur >= threshold) {
      if (full) full.classList.remove('hide');
      if (current) current.classList.add('hide');
    } else {
      var val = (threshold - cur) / 100;
      val = val != Math.round(val) ? val.toFixed(2).replace('.', ',') : String(val);
      var symbol = el.getAttribute('data-symbol') || '€0';
      var amount = el.querySelector('.free-delivery-bar__toolbar__text__current .fshbar');
      if (amount) amount.innerHTML = symbol.replace('0', val);
      if (current) current.classList.remove('hide');
      if (full) full.classList.add('hide');
    }
  }

  customElements.whenDefined('free-delivery-bar').then(function () {
    var C = customElements.get('free-delivery-bar');
    C.prototype.connectedCallback = function () { update(this); };
    document.querySelectorAll('free-delivery-bar').forEach(update);
  });
})();
